export default {
    methods: {
        initialitzeICheck(field) {
            var component = this;
            $('input[name=' + field + ']')
                .iCheck({
                    checkboxClass: 'icheckbox_square-blue',
                    radioClass: 'iradio_square-blue',
                    increaseArea: '20%',
                })
                .on('ifChecked', () => {
                    component.form.setField(field, true);
                    component.form.errors.clear(field);
                })
                .on('ifUnchecked', () => {
                    component.form.setField(field, '');
                });
        },
    },
};
